import React from 'react';
import { Card, Row, Col, } from 'react-bootstrap';
import moment from 'moment-timezone';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OneDPSJalons = ({
    dps,
    checkPoints,
}) => {
    return (<>
        <Card>
            <Card.Body>
                <small>Référence dossier: D{dps.idDPS}</small>
                <div className="timeline-simple">
                    {checkPoints.map((cp, i)=>{return(
                        <div className="timeline-item position-relative" key={i}>
                            <Row className="g-0">
                                <Col xs="auto" className="d-flex align-items-center">
                                    <h6 className="timeline-item-date fs-11 text-500 text-truncate mb-0 me-1">
                                        {
                                            cp.dateReelleExecution ? "Terminé"
                                            : cp.actifCheckPoint ? "En cours"
                                            : "A venir"
                                        }
                                    </h6>
                                    <div className="position-relative">
                                        <div className={"icon-item icon-item-md rounded-7 shadow-none bg-"+(
                                            cp.dateReelleExecution ? 'success'
                                            : cp.actifCheckPoint ? 'primary'
                                            : 'secondary'
                                        )}>
                                            <b className='text-white'>
                                                {
                                                    cp.dateReelleExecution ? <FontAwesomeIcon icon={'check'} />
                                                    : cp.actifCheckPoint ? <FontAwesomeIcon icon={'arrow-right'} />
                                                    : <FontAwesomeIcon icon={'spinner'} />
                                                }
                                            </b>
                                        </div>
                                    </div>
                                </Col>
                                <Col className="ps-3 fs-10 text-500">
                                    <div className="py-x1">
                                        <h5 className="fs-10">{cp.libelleCheckPointVueClient ? cp.libelleCheckPointVueClient : cp.libelleCheckPoint}</h5>
                                        <p className="mb-0">
                                            {
                                                cp.dateReelleExecution ? <>Réalisé le {moment(cp.dateReelleExecution).format('dddd DD/MM/YYYY')}</>
                                                : <>Prévu pour le {moment(cp.deadlineExecution).format('dddd DD/MM/YYYY')}</>
                                            }
                                        </p>
                                    </div>
                                    <hr className="my-0 text-300" />
                                </Col>
                            </Row>
                        </div>
                    )})}
                </div>
            </Card.Body>
        </Card>
    </>);
    
};

OneDPSJalons.propTypes = {};

export default OneDPSJalons;
